<span [dir]="options.dir!">
  <mat-sidenav-container
    class="mainWrapper"
    autosize
    autoFocus
    [ngClass]="{
      'sidebarNav-mini':
        options.sidenavCollapsed && options.navPos !== 'top' && !resView,
      'sidebarNav-horizontal': options.horizontal,
      cardBorder: options.cardBorder,
      orange_theme: options.activeTheme == 'orange_theme',
      blue_theme: options.activeTheme == 'blue_theme',
      aqua_theme: options.activeTheme == 'aqua_theme',
      purple_theme: options.activeTheme == 'purple_theme',
      green_theme: options.activeTheme == 'green_theme',
      cyan_theme: options.activeTheme == 'cyan_theme',
    }"
  >
    <!-- ============================================================== -->
    <!-- Vertical Sidebar -->
    <!-- ============================================================== -->
    @if (!options.horizontal) {
      <mat-sidenav
        #leftsidenav
        [mode]="isOver ? 'over' : 'side'"
        [opened]="
          options.navPos === 'side' &&
          options.sidenavOpened &&
          !isOver &&
          !resView
        "
        (openedChange)="onSidenavOpenedChange($event)"
        (closedStart)="onSidenavClosedStart()"
        class="sidebarNav"
      >
        <div class="flex-layout">
          <app-sidebar
            (toggleMobileNav)="sidenav.toggle()"
            [showToggle]="isOver"
          ></app-sidebar>
          <ng-scrollbar class="position-relative" style="height: 100%">
            <div class="sidebar-sections">
              @for (section of navSections; track section) {
                <div
                  class="nav-section"
                  [class.footer-section]="section.isFooter"
                >
                  @if (section.sectionTitle) {
                    <div class="section-title">{{ section.sectionTitle }}</div>
                  }
                  <mat-nav-list class="sidebar-list">
                    @for (item of section.items; track item) {
                      <app-nav-item [item]="item" (notify)="sidenav.toggle()">
                      </app-nav-item>
                    }
                  </mat-nav-list>
                  @if (!section.isFooter) {
                    <div class="section-divider"></div>
                  }
                </div>
              }
            </div>
          </ng-scrollbar>
        </div>
      </mat-sidenav>
    }

    <!-- ============================================================== -->
    <!-- horizontal Sidebar -->
    <!-- ============================================================== -->
    @if (resView) {
      <mat-sidenav
        #leftsidenav
        [mode]="'over'"
        [opened]="options.sidenavOpened && !isTablet"
        (openedChange)="onSidenavOpenedChange($event)"
        (closedStart)="onSidenavClosedStart()"
        class="sidebarNav"
      >
        <app-sidebar> </app-sidebar>
        <ng-scrollbar class="position-relative" style="height: 100%">
          <div class="sidebar-sections">
            @for (section of navSections; track section) {
              <div
                class="nav-section"
                [class.footer-section]="section.isFooter"
              >
                @if (section.sectionTitle) {
                  <div class="section-title">{{ section.sectionTitle }}</div>
                }
                <mat-nav-list class="sidebar-list">
                  @for (item of section.items; track item) {
                    <app-nav-item [item]="item" (notify)="sidenav.toggle()">
                    </app-nav-item>
                  }
                </mat-nav-list>
                @if (!section.isFooter) {
                  <div class="section-divider"></div>
                }
              </div>
            }
          </div>
        </ng-scrollbar>
        <div class="p-24 m-t-auto profile-bar">
          <div class="bg-light-accent d-flex align-items-center rounded p-16">
            <img
              src="/assets/images/profile/user-1.jpg"
              class="rounded-circle"
              width="40"
            />
            <div class="m-l-16">
              <h5 class="mat-subtitle-2 f-w-600">Mathew</h5>
              <span class="f-s-12">Designer</span>
            </div>
            <div class="m-l-auto">
              <a
                mat-icon-button
                [routerLink]="['/authentication/login']"
                class="d-flex justify-content-center"
              >
                <i-tabler
                  name="power"
                  class="text-primary icon-18 d-flex"
                ></i-tabler>
              </a>
            </div>
          </div>
        </div>
      </mat-sidenav>
    }

    <!-- ============================================================== -->
    <!-- Main Content -->
    <!-- ============================================================== -->
    <mat-sidenav-content class="contentWrapper" #content>
      <!-- ============================================================== -->
      <!-- VerticalHeader -->
      <!-- ============================================================== -->
      @if (!options.horizontal) {
        <app-header
          [showToggle]="!isOver"
          (toggleCollapsed)="toggleCollapsed()"
          (toggleMobileNav)="sidenav.toggle()"
          (toggleMobileFilterNav)="filterNavRight.toggle()"
        ></app-header>
      } @else {
        <!-- horizontal header -->
        <app-horizontal-header
          (toggleMobileNav)="sidenav.toggle()"
          (toggleMobileFilterNav)="filterNavRight.toggle()"
        ></app-horizontal-header>
      }
      @if (options.horizontal) {
        <app-horizontal-sidebar></app-horizontal-sidebar>
      }
      <div class="body-wrapper">
        <main
          class="pageWrapper p-0"
          [ngClass]="{
            maxWidth1: options.boxed,
          }"
        >
          <app-breadcrumb></app-breadcrumb>
          <!-- ============================================================== -->
          <!-- Outlet -->
          <!-- ============================================================== -->
          <router-outlet></router-outlet>
          <!--        <div class="customizerBtn">
            <button mat-fab color="accent" (click)="customizerRight.toggle()">
              <mat-icon>settings</mat-icon>
            </button>
          </div> -->
        </main>
      </div>
    </mat-sidenav-content>

    <mat-sidenav #customizerRight mode="over" position="end">
      <div
        class="p-x-16 p-y-20 d-flex align-items-center justify-content-between"
      >
        <h3 class="mat-subtitle-1 f-s-21 f-w-600">Settings</h3>
        <button class="d-lg-none" mat-button (click)="customizerRight.toggle()">
          Close
        </button>
      </div>
      <mat-divider></mat-divider>

      <app-customizer (optionsChange)="receiveOptions($event)"></app-customizer>
    </mat-sidenav>
  </mat-sidenav-container>

  <!-- ------------------------------------------------------------------
    Mobile Apps Sidebar
    ------------------------------------------------------------------ -->
  <mat-drawer #filterNavRight mode="over" position="end" class="filter-sidebar">
    <div>
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <app-branding></app-branding>
        </div>
        <button
          mat-icon-button
          (click)="filterNavRight.toggle()"
          class="d-flex justify-content-center"
        >
          <i-tabler name="x" class="icon-18 d-flex"></i-tabler>
        </button>
      </div>
      <div class="row p-x-16">
        @for (appdd of apps; track appdd.title) {
          <div class="col-12 text-hover-primary">
            <a
              [routerLink]="[appdd.link]"
              class="d-flex align-items-center text-decoration-none m-b-20"
            >
              <span
                class="text-{{ appdd.color }} bg-light-{{
                  appdd.color
                }} rounded icon-40 d-flex align-items-center justify-content-center"
              >
                <span
                  class="iconify icon-20"
                  [attr.data-icon]="appdd.icon"
                ></span>
              </span>

              <div class="m-l-16">
                <h5
                  class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text lh-sm"
                >
                  {{ appdd.title }}
                </h5>
                <span class="mat-body-1 f-s-12">{{ appdd.subtitle }}</span>
              </div>
            </a>
          </div>
        }
        <div class="position-relative p-x-16 p-b-16 w-100">
          <h4 class="f-s-18 f-w-600 mat-subtitle-1 m-b-20">Quick Links</h4>
          @for (quicklink of quicklinks; track quicklink.title) {
            <div class="text-hover-primary m-b-16">
              <a
                [routerLink]="[quicklink.link]"
                class="primary-hover-text text-decoration-none text-dark f-w-600 d-block"
                >{{ quicklink.title }}</a
              >
            </div>
          }
        </div>
      </div>
    </div>
  </mat-drawer>
</span>
